import Button from '@porterin/component-library/src/base-components/button/Button';
import Image from 'next/image';
import React from 'react';

export interface IconTitleProps extends React.HTMLAttributes<HTMLDivElement> {
  text: string;
  icon?: React.ReactNode | string;
  onIconClick?: () => void;
}

const IconTitleCmp: React.FC<IconTitleProps> = ({
  text,
  icon,
  onIconClick,
  className = '',
  ...props
}) => {
  return (
    <div
      {...props}
      data-testid="icon-title-wrapper"
      className={`
        flex items-center font-semibold text-[1.4rem] leading-[2rem]
        text-[#2d2f34] 
        ${className}
      `}
    >
      {icon && (
        <Button
          type="button"
          identifiers={{ id: 'icon-title-button' }}
          interactions={{ onClick: onIconClick }}
          className="p-0 bg-transparent shadow-none focus:outline-none"
        >
          {typeof icon === 'string' ? (
            <Image src={icon} height={24} width={24} alt="Icon" />
          ) : (
            icon
          )}
        </Button>
      )}
      <span className={icon ? 'ml-2' : ''} data-testid="icon-title-text">
        {text}
      </span>
    </div>
  );
};

export default IconTitleCmp;
